import axios from 'axios';

// baseURL desde entorno (.env / .env.production), con fallback a local.
const baseURL = process.env.REACT_APP_API_URL || 'http://localhost:4000';

const api = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Interceptor para agregar el token a las peticiones protegidas.
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token && config.headers) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Interceptor para manejar errores de autenticación (sesión expirada).
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 || error.response?.status === 403) {
      localStorage.removeItem('token');
      localStorage.setItem('sessionExpired', '1');
      // Solo redirige si estamos dentro del panel (no en las páginas públicas).
      if (!window.location.pathname.startsWith('/reportar')) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

// Instancia SIN token ni redirección para las páginas públicas (QR "Reporta seguro").
export const publicApi = axios.create({
  baseURL,
  headers: { 'Content-Type': 'application/json' }
});

export default api;
